import axios from "axios";


export const http4013 = axios.create({
    baseURL: process.env.REACT_APP_BOT_ANALYSIS,
});